import styled from 'styled-components'

export const ActivityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 4rem;
  grid-column-gap: 0rem;
  gap: 4rem 0rem;
  margin: 3.65rem 0;

  .gatsby-image-wrapper {
    flex: none;
    margin: 0 0 1.142rem 0;
  }

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1.5rem;
    grid-row-gap: 7rem;
    gap: 7rem 1.5rem;

    .gatsby-image-wrapper {
      margin: 0 1.142rem 0 0;
    }
    
  }
`

export const ActivityElement = styled.div`
  display: flex;

  flex-direction: column;
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

export const ActivityTextContainer = styled.div``
